import { render, staticRenderFns } from "./ReviewSection.vue?vue&type=template&id=1f28627a&scoped=true"
import script from "./ReviewSection.vue?vue&type=script&lang=js"
export * from "./ReviewSection.vue?vue&type=script&lang=js"
import style0 from "./ReviewSection.vue?vue&type=style&index=0&id=1f28627a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f28627a",
  null
  
)

export default component.exports